var _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAz = function SvgAz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f9c35",
    d: "M.1 0h640v480H.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M.1 0h640v320H.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b9e4",
    d: "M.1 0h640v160H.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 240,
    r: 72,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 60,
    fill: "#ed2939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m384 200 7.7 21.5 20.6-9.8-9.8 20.7L424 240l-21.5 7.7 9.8 20.6-20.6-9.8L384 280l-7.7-21.5-20.6 9.8 9.8-20.6L344 240l21.5-7.7-9.8-20.6 20.6 9.8z"
  })));
};
export default SvgAz;